/// <amd-module name="VSS/Features/Charts/AddressedTabularComponent" />
import React = require("react");

import { ChartProps } from "VSS/Features/Charts/Contracts";
import { TabularComponent } from "VSS/Features/Charts/Internal/TabularComponent";
import { IVssComponentContext } from "VSS/Platform/Layout";

import "VSS/LoaderPlugins/Css!Charts/Chart";

/** Responsible for rendering a screen-readable variant of chart content.
 * This was converted from JQuery implementation in Vssf WebPlatform Charts.  */
export class AddressedTabularComponent extends TabularComponent {
    constructor(props: ChartProps, context?: IVssComponentContext) {
        super(props, context);
    }

    /**
     * Note: The Pivot Table renderer uses a sparse, non-ordered addressed mode for placing content.
     * For rendering in an HTML table, generate a model of the table, and then render the model.
     * @param chartOptions
     */
    public render(): JSX.Element {
        if (!this.props.showAccessibleForm) {
            return null;
        }

        const chartOptions = this.props;
        const hasXAxisLabels = chartOptions.xAxis && chartOptions.xAxis.labelValues;
        const hasYAxisLabels = chartOptions.yAxis && chartOptions.yAxis.labelValues;

        let maxRow = 0,
            maxCol = 0,
            row: number,
            col: number,
            val: any;

        // Size the table model based on the bounds referenced in the options
        for (let i = 0; i < chartOptions.series.length; i++) {
            for (let j = 0; j < chartOptions.series[i].data.length; j++) {
                const element = chartOptions.series[i].data[j] as any[];
                col = element[0];
                maxCol = maxCol > col ? maxCol : col;
                row = element[1];
                maxRow = maxRow > row ? maxRow : row;
            }
        }

        const rowCount = maxRow + 1;
        const colCount = maxCol + 1;

        // Now, define default values for all cells, with outer loop going row by row.
        const tableValues: string[][] = [];
        for (let i = 0; i < rowCount; i++) {
            const rowValues: string[] = [];
            for (let j = 0; j < colCount; j++) {
                rowValues.push(""); // Define empty top-left label row corner cell. There's no meaningful info to put in it.
            }
            tableValues.push(rowValues);
        }

        // Place the content into the model.
        for (let i = 0; i < chartOptions.series.length; i++) {
            for (let j = 0; j < chartOptions.series[i].data.length; j++) {
                const element = chartOptions.series[i].data[j] as any[];
                col = element[0];
                row = element[1];
                val = element[2];
                tableValues[row][col] = val;
            }
        }

        // Now, render the model into tabular form.
        const thElements: JSX.Element[] = [];
        if (hasXAxisLabels) {
            if (hasYAxisLabels) {
                thElements.push(<th scope="col" key="labelCell" />);
            }
            for (let j = 0; j < colCount; j++) {
                thElements.push(
                    <th scope="col" key={j}>
                        {chartOptions.xAxis.labelValues[j]}
                    </th>
                );
            }
        }

        const bodyRows: JSX.Element[] = [];
        for (let i = 0; i < rowCount; i++) {
            const rowCells: JSX.Element[] = [];

            if (hasYAxisLabels) {
                rowCells.push(
                    <th key="headerCell" scope="row">
                        {chartOptions.yAxis.labelValues[i]}
                    </th>
                );
            }

            for (let j = 0; j < colCount; j++) {
                rowCells.push(<td key={j}>{tableValues[i][j]}</td>);
            }
            bodyRows.push(<tr key={i}>{rowCells}</tr>);
        }

        return this.renderTable(thElements, bodyRows);
    }
}
